module.exports = __webpack_public_path__ + "static/media/empty-order-bg.41bd59e0.png";